import Utils from "../util/Utils"

export function TableLine(props) {
    let { label, value } = props
    const isoDateTimeRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?(Z|[\+\-]\d{2}:\d{2})?$/;
    if ((value && isNaN(new Date(value).getTime()))||isoDateTimeRegex.test(value)){
        if (!isNaN(new Date(value))) {
            value = Utils.formatDateBooking(value, false);
        } else {
            value = Utils.reformatSuffixedDate(value);
        }
    }
    if (value) {
        return (
            <tr>
                <td style={{ fontWeight: 'bold', textAlign: 'right', paddingRight: '10px',width:'50%' }}>{label}</td>
                <td style={{overflowWrap: 'anywhere'}}>{value}</td>
            </tr>
        )
    }
    return <></>
}